import { render } from "./VolumeGrowth.vue?vue&type=template&id=686b750d&scoped=true"
import script from "./VolumeGrowth.vue?vue&type=script&lang=js"
export * from "./VolumeGrowth.vue?vue&type=script&lang=js"

import "./VolumeGrowth.vue?vue&type=style&index=0&id=686b750d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686b750d"]])

export default __exports__